import React from 'react'
import { Snackbar } from "@mui/material"
import useBSSLogger from "../../hooks/useBSSLogger";
import __t from "../../lib/traduzioni";

const {logger} = useBSSLogger();

/**
 * 
 * @param {import('@mui/material').SnackbarProps} props 
 * @returns 
 */
const BSSSnackbar = (props) => {

    props = {
        style: {zIndex: 10001},
        autoHideDuration: 6000,
        anchorOrigin: {vertical: 'bottom', horizontal: 'center' },
        ...props,
    }

    return (
        <Snackbar {...props} />
    )
}

export default BSSSnackbar;